import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AuthService } from '.';

@UntilDestroy()
@Injectable()
export class AuthInitializerService {
  constructor(private authService: AuthService) {}

  get user(): AccountInfo {
    return this.authService.activeAccount;
  }

  public async init(): Promise<void> {
    await this.authService.init();
  }
}
